enum StageViewState {
  Draft,
  Complete,
  Archive,
}

export const viewStateOptions: StageViewState[] = [0, 1, 2];
export default StageViewState;
